import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string | JSX.Element;
}

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: 'Do you provide mobile tinting services in Owings Mills?',
      answer: (
        <>
          Yes! Our <a href="/mobile-tinting" className="text-teal-600 hover:text-teal-700 font-medium">mobile tinting service</a> brings professional window tinting directly to your location in Owings Mills. We come to you for maximum convenience.
        </>
      ),
    },
    {
      question: 'What window tinting options are available in Owings Mills?',
      answer: (
        <>
          We offer <a href="/window-tinting" className="text-teal-600 hover:text-teal-700 font-medium">ceramic and standard window tinting</a>, <a href="/commercial-tinting" className="text-teal-600 hover:text-teal-700 font-medium">commercial building tinting</a>, <a href="/headlight-taillight-tinting" className="text-teal-600 hover:text-teal-700 font-medium">headlight/taillight tinting</a>, and <a href="/vehicle-decals" className="text-teal-600 hover:text-teal-700 font-medium">vehicle decals</a>. All backed by our lifetime warranty.
        </>
      ),
    },
    {
      question: 'How much does window tinting cost in Owings Mills?',
      answer: 'Pricing varies based on vehicle type and tint selection. Standard tinting starts at competitive rates, while premium ceramic tinting offers superior heat rejection and UV protection. Contact us for a free quote specific to your vehicle.',
    },
    {
      question: 'Is ceramic tint worth it in Owings Mills?',
      answer: 'Absolutely! Ceramic tint blocks up to 99% of UV rays and significantly reduces heat, making Maryland summers more comfortable. It also won\'t interfere with electronic devices and comes with our lifetime warranty.',
    },
    {
      question: 'Can you tint my truck or SUV in Owings Mills?',
      answer: 'Yes! We tint all vehicle types including sedans, trucks, SUVs, vans, and commercial vehicles. We have experience with all makes and models serving the Owings Mills area.',
    },
    {
      question: 'What areas near Owings Mills do you serve?',
      answer: 'We serve Owings Mills and surrounding areas including Reisterstown, Pikesville, Randallstown, Garrison, and nearby Baltimore County communities. Our mobile service makes it easy to reach you wherever you are.',
    },
    {
      question: 'Do you offer same-day tinting in Owings Mills?',
      answer: 'Yes! We offer same-day service for most appointments in Owings Mills. Most jobs take 2-4 hours, and you can wait on-site or we can notify you when your vehicle is ready.',
    },
    {
      question: 'Can you add custom decals to my vehicle in Owings Mills?',
      answer: (
        <>
          Yes! We create and install <a href="/vehicle-decals" className="text-teal-600 hover:text-teal-700 font-medium">custom vehicle decals</a> for personal branding, business advertising, or decorative purposes throughout Owings Mills and Baltimore County.
        </>
      ),
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about our window tinting services in Owings Mills
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors flex items-center justify-between cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-teal-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 py-4 bg-gray-50 text-gray-700 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Still have questions? We're here to help!
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
